module.exports = __webpack_public_path__ + "img/h1-layer1.9ce8d5fe.png";